export default __webpack_public_path__ + "static/media/declaracionjuradamemoria2023.82a84b94-1.30bb9e7d.png";